import ProblemSolution from "pages/ProblemSolution";

export default function ProblemSolutionPage() {
  return <ProblemSolution />;
}
